"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonTheme = void 0;
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _componentTheme = require("@clds/component-theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  palette,
  radius
} = _componentTheme.globalTheme;
const primary = {
  background: {
    color: palette.primary,
    contrast: palette.contrastInvert
  },
  focus: {
    color: palette.primary
  },
  border: {
    radius: radius.lg
  },
  typography: {
    type: 'contrastInvert'
  }
};
const secondary = {
  background: {
    color: palette.secondary,
    contrast: palette.contrastHigh
  },
  focus: {
    color: palette.primary
  },
  border: {
    radius: radius.lg
  },
  typography: {
    type: 'highContrast'
  }
};
const error = {
  background: {
    color: palette.error,
    contrast: palette.contrastInvert
  },
  focus: {
    color: palette.primary
  },
  border: {
    radius: radius.lg
  },
  typography: {
    type: 'contrastInvert'
  }
};
const warning = {
  background: {
    color: palette.warning,
    contrast: palette.contrastInvert
  },
  focus: {
    color: palette.primary
  },
  border: {
    radius: radius.lg
  },
  typography: {
    type: 'contrastInvert'
  }
};
const success = {
  background: {
    color: palette.success,
    contrast: palette.contrastInvert
  },
  focus: {
    color: palette.primary
  },
  border: {
    radius: radius.lg
  },
  typography: {
    type: 'contrastInvert'
  }
};
const link = {
  background: {
    color: palette.primary
  },
  typography: {
    type: 'url'
  },
  border: {
    radius: radius.lg
  },
  focus: {
    color: palette.primary
  }
};
const menu = {
  background: {
    color: palette.contrastHigh
  },
  typography: {
    type: 'lowContrast'
  },
  border: {
    radius: radius.lg
  },
  focus: {
    color: palette.primary
  }
};
const pillTheme = {
  border: {
    radius: '1000px'
  }
};
const buttonTheme = (0, _componentTheme.createTheme)({
  pill: {
    primary: (0, _merge2.default)({}, primary, pillTheme),
    secondary: (0, _merge2.default)({}, secondary, pillTheme),
    error: (0, _merge2.default)({}, error, pillTheme),
    warning: (0, _merge2.default)({}, warning, pillTheme),
    success: (0, _merge2.default)({}, success, pillTheme),
    link: (0, _merge2.default)({}, link, pillTheme),
    menu: (0, _merge2.default)({}, menu, pillTheme)
  },
  solid: {
    primary,
    secondary,
    error,
    warning,
    success,
    link,
    menu
  },
  group: {
    primary: {
      divider: {
        color: palette.surface,
        baseColor: palette.primary
      }
    },
    secondary: {
      divider: {
        color: palette.contrastHigh,
        baseColor: palette.secondary
      }
    }
  },
  split: {
    primary: {
      open: {
        accentColor: palette.backgroundAlt
      }
    },
    secondary: {
      open: {
        accentColor: palette.contrastHigh
      }
    }
  }
}, 'button');
exports.buttonTheme = buttonTheme;
//# sourceMappingURL=buttonTheme.js.map